import { render, staticRenderFns } from "./products.vue?vue&type=template&id=98228c8a&scoped=true"
import script from "./products.js?vue&type=script&lang=js&external"
export * from "./products.js?vue&type=script&lang=js&external"
import style0 from "./products.vue?vue&type=style&index=0&id=98228c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98228c8a",
  null
  
)

export default component.exports